import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden bg-[#0A0A0A]" data-id="element-142">
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto mt-20" data-id="element-143">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="md:text-7xl lg:text-8xl mb-6 drop-shadow-lg text-[56px] font-[700] font-[Manrope,_sans-serif] text-[#EB5353]" data-id="element-144">
          SGHarems.com 新加坡后宫网
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl mb-10 max-w-2xl mx-auto drop-shadow-md font-[400] text-[#FFE46A]" data-id="element-145">
          新加坡后宫网是高端伴游陪游按摩援交一站式平台,
          为新加坡绅士提供优质伴游、按摩娱乐体验，覆盖全新加坡。 SGHarem,
          Singapore's high-class escort directory connecting you with premium
          companions, massage services, and escorts across Singapore.
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-146">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-147">
            <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#D4AF37] text-[#0A0A0A] px-10 py-4 rounded-sm text-lg font-medium hover:bg-[#F0D060] transition-colors duration-300 shadow-lg" data-id="element-148">
              Enter website 进入官网
            </a>
            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#2A2A2A] text-[#F5F0EB] px-10 py-4 rounded-sm text-lg font-medium hover:bg-[#D4AF37] hover:text-[#0A0A0A] transition-colors duration-300 shadow-lg border border-[#D4AF37]" data-id="element-149">
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-150">
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-151" />
              </svg>
              Telegram Channel
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}